import { useEffect } from "react"
import { BetSlipFragment } from "../../graphql/core-types"
import { getMutedWinSide, Placement, WinAnimation, WinSound } from "../../helpers/overlay-settings"
import { playWinSound } from "../../helpers/win-sound"
import { BetWonAnimation } from "../bet-won-animation/bet-won-animation"
import { BetWonMuted } from "../bet-won-muted/bet-won-muted"

type WinCelebrationProps = {
  style: Exclude<WinAnimation, 'off'>
  sound: WinSound
  betSlip: BetSlipFragment
  betList: Placement
  onComplete: () => void
}

// how long after the celebration starts its sound plays, lined up with each style's entrance. moments to aim for:
// fullscreen: the stripes and scrim fade in from 50ms, the hero is fully in by ~400ms
// muted: the panel slides in from 50ms, the count starts at ~450ms and lands with a pop at ~1850ms
const WIN_SOUND_DELAY_MS: Record<Exclude<WinAnimation, 'off'>, number> = {
  fullscreen: 50,
  muted: 450,
}

// one place that picks the celebration, shared by the overlay and the link builder's preview button
export const WinCelebration = ({ style, sound, betSlip, betList, onComplete }: WinCelebrationProps) => {
  // both callers remount this with a new key per win, so it plays once per celebration
  useEffect(() => {
    if (sound !== 'on') return
    // cleared if the celebration is cut short, so a replaced win doesn't play late over the next one
    const soundTimeout = setTimeout(playWinSound, WIN_SOUND_DELAY_MS[style])
    return () => clearTimeout(soundTimeout)
  }, [])

  return style === 'muted'
    ? <BetWonMuted betSlip={betSlip} side={getMutedWinSide(betList)} onComplete={onComplete} />
    : <BetWonAnimation betSlip={betSlip} onComplete={onComplete} />
}
